
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"i-fill",attrs:{"cx":"22","cy":"34","r":"6","fill":"#D0EFEC"}}),_c('circle',{staticClass:"i-Ellipse 10",attrs:{"cx":"23.5","cy":"31.5","r":"13","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 11",attrs:{"cx":"23.5","cy":"31.5","r":"5","stroke":"#234652"}}),_c('path',{staticClass:"i-Rectangle 18",attrs:{"stroke":"#234652","d":"M16 21v-9.5a7.5 7.5 0 0 1 15 0V21"}}),_c('path',{staticClass:"i-Rectangle 19",attrs:{"stroke":"#234652","d":"M19 19v-7.5a4.5 4.5 0 1 1 9 0V19"}}),_c('circle',{staticClass:"i-Ellipse 13",attrs:{"cx":"23.5","cy":"31.5","r":"9","stroke":"#234652","stroke-dasharray":"1 6"}})])
          )
        }
      }
    